import { openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  "data-test": "settings-tab",
  class: "customer-settings"
}

import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'

import ProfileArchive from '@/components/customers/profile/ProfileArchive.vue'
import ProfileBilling from '@/components/customers/profile/ProfileBilling.vue'
import ProfileCommunication from '@/components/customers/profile/ProfileCommunication.vue'
import { fetchCustomerPair } from '@/composables/useCustomerRecord'
import privilegeService from '@/services/privilege.service'


export default {
  __name: 'CustomerSettingsTab',
  setup(__props) {

const route = useRoute()

const customerId = computed(() => String(route.params.id))
const canUpdateCustomerProfile = computed(() =>
  privilegeService.canAccessResourceAction('customer_profile', null, 'update')
)

watch(customerId, id => fetchCustomerPair(id), { immediate: true })

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(ProfileBilling, {
      key: customerId.value,
      "conversation-user-pair-id": customerId.value,
      editable: canUpdateCustomerProfile.value
    }, null, 8, ["conversation-user-pair-id", "editable"])),
    (canUpdateCustomerProfile.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(ProfileCommunication, { "conversation-user-pair-id": customerId.value }, null, 8, ["conversation-user-pair-id"]),
          _createVNode(ProfileArchive, { "conversation-user-pair-id": customerId.value }, null, 8, ["conversation-user-pair-id"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

}